import http from "../http-common";

class ProjectUploadService {
  createproject(data) {
    return http.post('/project', data);
  }
  createstu(data) {
    return http.post('/project_stu', data);
  }
  getcounts(mood,month,year,userId) {
    return http.get(`/counts?moodId=`+mood+'&&month='+month+"&&year="+year+"&&userId="+userId);
  }
  getprojects(year,id) {
    return http.get(`/project?year=`+year+'&&userId='+id);
  }
  getproject(id) {
    return http.get(`/project/`+id);
  }
  getstudent(id) {
    return http.get(`/project_stu/`+id);
  }
  createfile(data) {
    return http.post('/project_file', data);
  }
  getadvisor() {
    return http.get(`/advisor`);
  }
  updateproject(id, data) {
    return http.put(`/project/${id}`, data);
  }
  updatestatus(id, data) {
    return http.put(`/project/updatestatus/${id}`, data);
  }
  getyears() {
    return http.get(`/project/getyears`);
  }
  
}

export default new ProjectUploadService();